const filters = {
  'filters-breadcrumbs': 'Фильтры',
  'filters-column-value': 'Значение',
  'filters-filter-title': 'Фильтр',
  'filters-filter-form-value': 'Значение',
  'filters-filter-form-value-tooltip': 'Поле заполняется фильтруемыми значениями таких типов, как лейблы, категории или теги',
  'filters-filter-form-value-placeholder': 'Выберите значение фильтра',
  'filters-attached-to-groups': 'Невозможно удалить фильтр, так как он используется в группах: ',
  'filters-option-label': 'Лейбл',
  'filters-option-category': 'Категория',
  'filters-option-tag': 'Тег',
  'filters-option-combined': 'Комбинированный',
};

export default filters;
